import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

const commonBtnFontStyles = {
    fontFamily: fonts.primary,
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: 'normal',
    margin: 0,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14)],
    letterSpacing: pxToRem(1.5),
    cursor: 'pointer',
    fontStyle: 'normal'
}

const commonButtonStyles = {
    ...commonBtnFontStyles,
    lineHeight: pxToRem(13.5),
    borderRadius: 'none',
    minHeight: [pxToRem(35), pxToRem(40)],
    minWidth: [pxToRem(260), pxToRem(260), pxToRem(295)],
    padding: [`${pxToRem(10)} ${pxToRem(20)}`, `${pxToRem(12)} ${pxToRem(20)}`],
    textAlign: 'center'
}

const commonLinkStyles = {
    ...commonBtnFontStyles,
    width: 'fit-content',
    backgroundColor: 'transparent',
    padding: `0 ${pxToRem(1)}`,
    _hover: {
        textDecoration: 'underline'
    }
}

export default {
    global: {
        html: {
            overflowX: 'hidden',
            width: '100%'
        },
        'html, body': {
            backgroundColor: 'white',
            color: 'black',
            fontFamily: fonts.primary
        },
        '.skip-link': {
            position: 'absolute',
            top: pxToRem(-100),
            left: pxToRem(10),
            zIndex: 'skipLink',

            bg: 'white',
            color: 'blue.600',

            px: '4',
            py: '3',

            borderRadius: 'lg',
            fontWeight: 'semibold',
            textDecoration: 'none',

            opacity: 0
        },

        '.skip-link:focus, .skip-link:focus-visible': {
            top: pxToRem(10),
            opacity: 1,
            boxShadow: 'outline'
        },
        // Override Bootstrap container horizontal padding globally
        '.container, .container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl':
            {
                '--bs-gutter-x': '0 !important',
                paddingLeft: '0 !important',
                paddingRight: '0 !important'
            },
        // Fix slick carousel overflow issues
        '.slick-slider': {
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box'
        },
        '.slick-list': {
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
            boxSizing: 'border-box'
        },
        '.slick-track': {
            display: 'flex',
            boxSizing: 'border-box'
        },
        '.slick-slide': {
            boxSizing: 'border-box',
            minWidth: 0
        },
        body: {
            minHeight: '100vh',
            color: 'black',
            backgroundColor: 'white',
            fontFamily: fonts.primary,
            overflowX: 'hidden',
            width: '100%',
            maxWidth: '100vw',
            a: {
                textDecoration: 'none'
            },
            '.fw-600': {
                fontWeight: '600 !important'
            },
            '.fw-500': {
                fontWeight: '500 !important'
            },
            '.fw-400': {
                fontWeight: '400 !important'
            },
            'h1,h2,h3,h4,h5,h6': {
                fontFamily: fonts.primary,
                fontStyle: 'normal',
                lineHeight: 'auto',
                textTransform: 'uppercase'
            },
            h1: {
                fontWeight: 600,
                fontSize: [pxToRem(22), pxToRem(22), pxToRem(30)],
                letterSpacing: [pxToRem(3.3), pxToRem(3.3), pxToRem(4.5)]
            },
            h2: {
                fontWeight: 600,
                fontSize: [pxToRem(18), pxToRem(18), pxToRem(22)],
                letterSpacing: [pxToRem(2.7), pxToRem(2.7), pxToRem(3.3)]
            },
            h3: {
                fontWeight: 600,
                fontSize: [pxToRem(16), pxToRem(16), pxToRem(18)],
                letterSpacing: [pxToRem(2.4), pxToRem(2.4), pxToRem(3.3)]
            },
            h4: {
                fontWeight: 600,
                fontSize: [pxToRem(14), pxToRem(14), pxToRem(16)],
                letterSpacing: [pxToRem(2.1), pxToRem(2.1), pxToRem(2.4)]
            },
            h5: {
                fontWeight: 500,
                fontSize: [pxToRem(12), pxToRem(12), pxToRem(14)],
                letterSpacing: [pxToRem(0.96), pxToRem(0.96), pxToRem(2.1)]
            },
            h6: {
                fontWeight: 500,
                fontSize: [pxToRem(10), pxToRem(10), pxToRem(12)],
                letterSpacing: [pxToRem(0.8), pxToRem(0.8), pxToRem(1)]
            },
            '.para': {
                fontFamily: fonts.primary,
                fontStyle: 'normal',
                lineHeight: 'auto',
                fontWeight: 400,
                fontSize: [pxToRem(14), pxToRem(14), pxToRem(16)],
                letterSpacing: [pxToRem(1.12), pxToRem(1.12), pxToRem(1.28)]
            },
            '.des-text': {
                fontFamily: fonts.primary,
                fontStyle: 'normal',
                lineHeight: 'auto',
                fontWeight: 400,
                fontSize: [pxToRem(12), pxToRem(12), pxToRem(13)],
                letterSpacing: [pxToRem(0.96), pxToRem(0.96), pxToRem(1.04)]
            },
            '.button-primary': {
                ...commonButtonStyles,
                border: `${pxToRem(1)} solid`,
                backgroundColor: 'cav_red',
                color: 'white',
                _hover: {bg: 'white', color: 'cav_red'},
                _active: {bg: 'white', color: 'cav_red'}
            },
            '.button-secondary': {
                ...commonButtonStyles,
                backgroundColor: 'white',
                color: 'cav_red',
                _hover: {bg: 'cav_red', color: 'white'},
                _active: {bg: 'cav_red', color: 'white'}
            },
            '.button-tertiary': {
                ...commonButtonStyles,
                backgroundColor: 'cav_purple',
                color: 'white',
                _hover: {bg: 'white', color: 'cav_purple'},
                _active: {bg: 'white', color: 'cav_purple'}
            },
            '.button-outline': {
                ...commonButtonStyles,
                // minWidth: {base: '100%', lg: '100%'},
                backgroundColor: 'transparent',
                border: `${pxToRem(1)} solid`,
                color: 'cav_calltoaction_darkred',
                _hover: {bg: 'cav_calltoaction_darkred', color: 'white'},
                _active: {bg: 'cav_calltoaction_darkred', color: 'white'},
                borderColor: 'cav_calltoaction_darkred'
            },
            '.primary-link': {
                ...commonLinkStyles,
                color: 'cav_red'
            },
            '.secondary-link': {
                ...commonLinkStyles,
                color: 'white'
            },
            '.link-tertiary': {
                ...commonLinkStyles,
                color: 'black'
            },
            'li, td, th, span, label, div': {
                fontFamily: fonts.primary
            },
            'b, strong': {
                fontWeight: 700
            },
            p: {
                fontFamily: fonts.primary,
                fontStyle: 'normal',
                lineHeight: 'auto',
                fontWeight: 400,
                fontSize: [pxToRem(14), pxToRem(14), pxToRem(16)],
                letterSpacing: [pxToRem(1.12), pxToRem(1.12), pxToRem(1.28)]
            }
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh',
            overflowX: 'hidden',
            width: '100%',
            maxWidth: '100%'
        },
        '.loyalty-container': {
            width: '100%',
            margin: '0 auto',
            padding: `0 ${pxToRem(15)}`
        },
        '.logo-section': {
            textAlign: 'center',
            margin: `${pxToRem(16)} 0`
        },
        '.logo-section img': {
            maxWidth: '100%',
            height: 'auto',
            display: 'block',
            margin: '0 auto'
        },
        '.main-heading': {
            textAlign: 'center',
            fontSize: pxToRem(24),
            letterSpacing: pxToRem(1),
            marginBottom: pxToRem(24)
        },
        '.benefits-grid': {
            display: 'flex',
            flexWrap: 'wrap',
            margin: `0 -${pxToRem(12)} ${pxToRem(16)}`,
            justifyContent: 'center'
        },
        '.benefit-item': {
            flex: '0 0 100%',
            maxWidth: '100%',
            padding: `0 ${pxToRem(12)} ${pxToRem(24)}`
        },
        '.benefit-item img': {
            maxWidth: '100%',
            height: 'auto',
            display: 'block'
        },
        '@media (min-width: 768px)': {
            '.benefit-item': {
                flex: '0 0 50%',
                maxWidth: '50%'
            }
        },
        '@media (min-width: 992px)': {
            '.benefit-item': {
                flex: '0 0 34%',
                maxWidth: '33.33%'
            }
        },
        '.cta-section': {
            textAlign: 'center',
            margin: `${pxToRem(24)} 0`
        },
        '.cta-button': {
            display: 'inline-block',
            backgroundColor: 'cav_red',
            color: 'white',
            letterSpacing: pxToRem(1),
            textTransform: 'uppercase',
            fontWeight: 'bold',
            padding: {base: `${pxToRem(10)} ${pxToRem(25)}`, md: `${pxToRem(10)} ${pxToRem(60)}`},
            border: '1px solid #AE132A',
            borderRadius: 0,
            textDecoration: 'none',
            cursor: 'pointer'
        },
        '.cta-button:hover': {
            backgroundColor: 'white',
            color: 'cav_red'
        },
        '.section-heading': {
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: pxToRem(20),
            margin: `${pxToRem(48)} 0 ${pxToRem(24)}`
        },
        '.legal-text': {
            textAlign: 'center',
            fontSize: pxToRem(14),
            marginTop: pxToRem(48),
            marginBottom: pxToRem(48)
        },
        '.legal-text:last-child': {
            marginBottom: pxToRem(48)
        },
        '.legal-link': {
            color: 'cav_red',
            textDecoration: 'underline',
            fontWeight: 'bold'
        }
    }
}
